module.exports = __webpack_public_path__ + "img/avatar2.e85a198a.png";